import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../config/config";
import axiosInstance from "../../../interceptors";

const getCandidateIntegrityScore = createAsyncThunk(
  "getCandidateIntegrityScore",
  async ({ interviewId, userId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/job-posting/api/candidate-integrity-score/get`,
        { interviewId, userId }
      );
      if (data.success) return data.data;
      return rejectWithValue(data.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const computeCandidateIntegrityScore = createAsyncThunk(
  "computeCandidateIntegrityScore",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/job-posting/api/candidate-integrity-score/compute`,
        payload
      );
      if (data.success) return data.data;
      return rejectWithValue(data.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export { getCandidateIntegrityScore, computeCandidateIntegrityScore };
